<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>
      რატომ უნდა შეიძინო ავტომობილი ამერიკის აუქციონზე?
    </h1>
    <h6>თებერვალი 2023</h6>
    <br />

    <p>
      შენ გარშემოც სულ უფრო მეტი ადამიანი ყიდულობს ავტომობილს უცხოეთიდან? ონლაინ შოპინგი - სახალისოა, მაგრამ როცა ნივთის
      ფასი ათობით ათას, ან თუნდაც ერთეულ უცხოურ ვალუტაში ითარგმნება, რთულია გადაწყვეტილება „add to cart“ პრინციპით
      მიიღო. და მაინც, რატომ არის ავტომობილის ამერიკის აუქციონებზე შეძენა კარგი აზრი?
    </p>

    <img src="../../../../assets/blog/auction/img1.jpg" alt="" />

    <p>
      <i class="inline-header dark-blue">ფასი</i> - კერძო პირები, გაყიდვების ვებ-გვერდებზე საკუთარი ავტომობილის
      განთავსებისას მეტად სარფიან შეთავაზებას ელიან. მათ უმეტესად არსად ეჩქარებათ, არც დისკომოფორტს განიცდიან
      დაგვიანებული გაყიდვისას და მითუმეტეს, არც არახელსაყრელი პირობებით აპირებენ მასთან გამომშვიდობებას. აუქციონებზე კი,
      უმეტესად ისეთი ავტომობილები ხვდება, რომელთა გაყიდვაც რაც შეიძლება სწრაფად სურთ, მოქმედი პრინციპიდან გამომდინარე კი
      საუკეთესო შეთავაზების მისაღებად ლიმიტირებული დრო აქვთ.
    </p>

    <p>
      <i class="inline-header middle-blue">არჩევანია</i> - საუბარია ამერიკის რამდენიმე უმსხვილეს აუქციონზე, სადაც
      ავტომობილების უდიდესი რაოდენობა იყრის თავს და შენთვის სასურველი მარკა-მოდელის შერჩევა ძალიან მარტივია.
    </p>

    <p>
      <i class="inline-header green">სიმარტივე</i> - ტაფტოლოგია არ გეგონოთ, აუქციონზე ავტომობილის შერჩევა მინიმალურ
      ციფრულ უნარებს მოითხოვს.
    </p>

    <p>
      <i class="inline-header purple">ხელმისაწვდომობა</i> - დაფიქრდი, მობილური ტელეფონით თუ ლეპტოპით ონლაინ აუქციონზე
      შესვლა ნებისმიერ დროს, ნებისმიერ ადგილას შეგიძლია. მთავარია გქონდეს სურვილი და სწრაფი ინტერნეტი, რათა მოთხოვნის
      განთავსებისას ტექნიკურმა შეფერხებებმა არ შეგიშალოს ხელი.
    </p>

    <p>
      <i class="inline-header light-blue">მოქნილობა</i> - მიუხედავად იმისა, რომ შესაძლებელია ახლა ბიუჯეტზე დიდი -
      სურვილი გაქვს, შენთვის საინტერესო პროდუქტს გაგაცნობთ. თუ აუქციონზე ავტომობილის შეძენისას თიბისი ლიზინგის პარტნიორი
      იმპორტიორი კომპანიის მომსახურებით ისარგებლებ, დაფინანსების მოპოვება ზუსტად 1 საათში შეგიძლია. იმპორტის შემთხვევაში
      თანამონაწილეობა 20%-დან იწყება, რაც დაგვეთანხმები, რომ მინიმალური ინვესტიციაა აქტივის შესაძენად. ლიზინგის მოცულობა
      1,500$-150,000$ (ექვივალენტი ლარში) განისაზღვრება და საოპერაციო ნაწილი შენს მინიმალურ ჩართულობას მოითხოვს. ამ
      შემთხვევაში მხოლოდ თანამონაწილეობის თანხის გადახდა გიწევს მისი ჩამოსვლის, განბაჟებისა და გადაფორმების შემდეგომ კი,
      იწყებ ლიზინგის ყოველთვიური გადასახადის გადახდას.
    </p>

    <p>
      მოკლედ, თუ ავტომობილის დაფინანსება აქ. ახლა გსურს, რადგან შენს გაჯეტში საუკეთესო შეთავაზება აღმოაჩინე, უკვე იცი
      ვისაც შეგიძლია მიმართო. ერთგული, საიმედო და კომფორტული ოთხბორბლიანი პარტნიორის შერჩევას გისურვებთ!
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      Why Should You Buy a Car at an American Auction?
    </h1>
    <h6>December 2023</h6>
    <br />

    <p>
      Are more and more people around you buying cars from abroad? Online shopping is fun, but when the price of the
      item translates into tens of thousands or even several foreign currencies, it’s hard to make a decision based on
      the “add to cart” principle. So, why is buying a car at American auctions a good idea?
    </p>

    <img src="../../../../assets/blog/auction/img1.jpg" alt="" />

    <p>
      <i class="inline-header dark-blue">Price</i> - When private individuals list their cars on sales websites, they
      generally expect a more profitable offer. They are usually in no rush, don't experience discomfort from delayed
      sales, and especially don't plan to part with their vehicle under unfavorable conditions. On the other hand, cars
      at auctions are typically those that the sellers want to sell as quickly as possible, and based on the existing
      principle, they have a limited time to secure the best offer.
    </p>

    <p>
      <i class="inline-header middle-blue">Choice</i> - We’re talking about some of the largest auctions in the U.S.,
      where a huge number of vehicles are listed, making it very easy to select the make and model you want.
    </p>

    <p>
      <i class="inline-header green">Simplicity</i> - This isn’t a tautology; selecting a car at an auction requires
      minimal digital skills.
    </p>

    <p>
      <i class="inline-header purple">Accessibility</i> - Think about it, you can join an online auction from your
      mobile phone or laptop at any time and from anywhere. The only thing you need is the desire and a fast internet
      connection, so that technical issues don't get in the way while placing your bid.
    </p>

    <p>
      <i class="inline-header light-blue">Flexibiility</i> - Even if you have a bigger budget than you initially
      planned, if you choose to purchase your car at an auction through a TBC Leasing partner importer, you can secure
      financing in just 1 hour. In the case of importation, the down payment starts from 20%, which you’ll agree is a
      minimal investment to acquire the asset. The lease volume is determined between $1,500–$150,000 (equivalent in
      GEL) and the operational part requires minimal involvement on your part. In this case, you only need to pay the
      down payment, and after the vehicle's arrival, customs clearance, and re-registration, you’ll start paying the
      monthly leasing fee.
    </p>

    <p>
      In short, if you want financing for your vehicle purchase now, because you’ve found the best deal in your gadget,
      you already know whom to contact. We wish you a loyal, reliable, and comfortable four-wheeled partner!
    </p>
  </div>
</ng-container>
